import { useGetCustomerTribe } from "@/services/api";
import { useGetDetailTribe } from "@/services/api";

const useNoEligibleProductsYet = () => {
  const { data: customerTribe } = useGetCustomerTribe();
  const { data: tribeDetail } = useGetDetailTribe(customerTribe?.tribeId || "");

  const noEligibleProductsYet =
    !tribeDetail?.eligibleSimCount &&
    tribeDetail?.memberInfo?.some(
      (member) => member.onpEligibleSims && member.onpEligibleSims > 0,
    );

  return noEligibleProductsYet;
};

export default useNoEligibleProductsYet;
